(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoke-homebanner"] && !Shopify.designMode) return;
  try {
    
// 兜底处理：禁用Dawn模板默认动画 + 确保移动端图片显示
document.addEventListener('DOMContentLoaded', function() {
  const banner = document.querySelector('.eu-banner');
  if (!banner) return;

  // 移除Dawn自动添加的动画类
  const removeAnimateClasses = (el) => {
    const animateClasses = ['animate--fade-in', 'animate--slide-up'];
    animateClasses.forEach(cls => el.classList.remove(cls));
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.opacity = '1';
  };

  removeAnimateClasses(banner);
  banner.querySelectorAll('*').forEach(removeAnimateClasses);

  // 移动端强制显示图片
  const isMobile = window.innerWidth <= 767;
  const mobileImg = document.querySelector('.eu-banner__mobile-img');
  if (isMobile && mobileImg) {
    mobileImg.style.display = 'block';
  }

  // 监听窗口大小变化
  window.addEventListener('resize', function() {
    const isMobileNow = window.innerWidth <= 767;
    if (mobileImg) {
      mobileImg.style.display = isMobileNow ? 'block' : (section.settings.banner_video ? 'none' : 'block');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoke-homevideo"] && !Shopify.designMode) return;
  try {
    
// 仅用于兜底禁用Dawn可能动态添加的动画类
document.addEventListener('DOMContentLoaded', function() {
  const heroContainer = document.querySelector('.hero-container');
  if (!heroContainer) return;

  // 移除所有动画相关类名
  const removeAnimationClasses = (element) => {
    const animationClasses = ['animate--fade-in', 'animate--slide-up', 'animate--slide-left', 'animate--slide-right'];
    animationClasses.forEach(cls => element.classList.remove(cls));
    element.style.animation = 'none';
    element.style.transform = 'none';
    element.style.opacity = '1';
  };

  // 处理容器和所有子元素
  removeAnimationClasses(heroContainer);
  heroContainer.querySelectorAll('*').forEach(removeAnimationClasses);

  // 监听DOM变化，防止动态添加动画类
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        removeAnimationClasses(mutation.target);
      }
    });
  });

  observer.observe(heroContainer, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});

  } catch(e) { console.error(e); }
})();
})();
